import { toHalfWidth } from '../../../utils/editBookingNormalize'

// 車両番号入力のサニタイズ：全角数字を半角に変換した上で半角数字以外を除去し、4 桁に切り詰める（PC 版仕様）
export const sanitizeVehicleNumber = (input: string): string =>
  toHalfWidth(input)
    .replace(/[^0-9]/g, '')
    .slice(0, 4)
